module.exports = __webpack_public_path__ + "img/badge-list-thumb-131.3d3b6425.png";